<template>
  <div>
    <h4 class="title">
      رزرو غذا
    </h4>
    <b-overlay :show="calendarProgress">
      <persian-calendar
        :events-list="events"
        :display-period.sync="period"
        :min-date="min"
        disable-past-days
        class="cursor-pointer"
        @on-day-click="onDayClick"
      >
        <template
          slot="event"
          slot-scope="i"
        >
          <div
            :key="i.value.id"
            style="padding: 5px;"
            :class="i.value.classes"
            :style="`top:${i.top};background-color:${i.value.color};`"
            class="vpc_event"
            @click="onEventClick(i.value)"
          >
            <!--  Anything You Wish -->
            <span
              class="vpc_event-title"
              style="padding: 5px!important"
              :class="i.value.classes"
            >
              {{ i.value.title }}
            </span>
          </div>
        </template>
      </persian-calendar>
    </b-overlay>
    <b-modal
      v-model="showModal"
      centered
      :title="`منوی غذا (${menuTitle})`"
      size="lg"
      :no-close-on-backdrop="true"
      hide-footer
    >
      <b-overlay :show="onProgress">
        <b-table
          :fields="fields"
          :items="items"
          hover
          striped
          responsive
        >
          <template #table-busy>
            <div class="text-center text-info my-2">
              <b-spinner class="align-middle" />
              <strong> درحال دریافت اطلاعات...</strong>
            </div>
          </template>

          <template #cell(isActive)="data">
            <b-avatar
              :id="`user-row-${data.item.id}`"
              size="32"
              :variant="data.value ? 'light-success': 'light-danger'"
            >
              <feather-icon
                :icon="data.value ? 'CheckIcon': 'XIcon'"
              />
            </b-avatar>
          </template>
          <template #cell(action)="data">

            <b-button
              v-if="data.item.isReserved && data.item.isAllowDate"
              v-ripple.400="'rgba(40, 199, 111, 0.15)'"
              variant="flat-danger"
              @click="deleteBook(data.item.id)"
            >
              <feather-icon
                icon="Trash2Icon"
                class="mr-50"
              />
              <span class="align-middle">انصراف</span>
            </b-button>
            <b-button
              v-if="!data.item.isReserved && data.item.isAllowDate"
              v-ripple.400="'rgba(40, 199, 111, 0.15)'"
              variant="flat-success"
              @click="book(data.item.id)"
            >
              <feather-icon
                icon="ShoppingCartIcon"
                class="mr-50"
              />
              <span class="align-middle">انتخاب</span>
            </b-button>
          </template>

        </b-table>
      </b-overlay>
    </b-modal>

  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardHeader,
  BCardBody,
  BForm,
  BFormGroup,
  BFormInput,
  BOverlay,
  BInputGroup,
  BInputGroupAppend, BFormInvalidFeedback, BFormCheckbox, BModal, BTabs, BTab, BButton,
  BTable, BDropdownItem, BAvatar, BBadge, BSpinner, BDropdown,
} from 'bootstrap-vue'
import VSelect from 'vue-select'
import ripple from 'vue-ripple-directive'
import PersianCalendar from '@/views/components/reservation/PersianCalendar.vue'
import { parsMomentEvent, PersianNowDate } from '@/libs/utils'

export default {
  name: 'Reservation',
  components: {
    BDropdown,
    BSpinner,
    BBadge,
    BAvatar,
    BDropdownItem,
    BTab,
    BTabs,
    BFormCheckbox,
    BFormInvalidFeedback,
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BForm,
    BFormGroup,
    BFormInput,
    VSelect,
    BOverlay,
    BInputGroup,
    BInputGroupAppend,
    BModal,
    PersianCalendar,
    BButton,
    BTable,
  },
  directives: {
    ripple,
  },
  data() {
    return {
      onProgress: false,
      calendarProgress: false,
      showModal: false,
      period: 'month',
      min: this.$moment(new Date(), 'jYYYY/jMM/jDD'),
      events: [],
      selectedDay: null,
      menuTitle: '',
      fields: [
        {
          key: 'food',
          label: 'نام غذا',
        },
        {
          key: 'meal',
          label: 'وعده غذایی',
        },
        {
          key: 'period',
          label: 'مهلت رزرو',
        },
        {
          key: 'action',
          label: 'عملیات',
        },
      ],
      items: [],
      editModal: false,
      menu: {},
    }
  },
  mounted() {
    this.getEvents()
  },
  methods: {
    async getEvents() {
      this.calendarProgress = true
      await this.$http.get('reservations')
        .then(({ data }) => {
          if (data.status) {
            this.events = data.menus.map(event => parsMomentEvent(event, this.$moment))
          } else {
            this.$bvToast.toast(data.message ?? 'دریافت لیست غذا با خطا مواجه شد', {
              title: 'خطا در دریافت اطلاعات',
              toaster: 'b-toaster-top-right',
              variant: 'danger',
            })
          }
        })
        .catch(error => {
          this.$bvToast.toast(error.response.data.message ?? error.message, {
            title: 'خطا در دریافت اطلاعات',
            toaster: 'b-toaster-top-right',
            variant: 'danger',
          })
        })

      this.calendarProgress = false
    },
    nextPage(event) {
      console.log(event.format())
    },
    onEventClick(e) {
      this.onDayClick(this.$moment(e.startDateTime))
    },
    onDayClick(event) {
      console.log('event', event)
      this.showModal = true
      this.selectedDay = event
      this.menuTitle = event.format('jDD jMMMM jYYYY')
      this.getDayMenu()
    },
    getDayMenu() {
      this.onProgress = true
      this.$http.get(`reservations/${PersianNowDate(this.selectedDay, false, true)}`)
        .then(({ data }) => {
          if (data.status) {
            this.items = data.items
          } else {
            this.$bvToast.toast(data.message ?? 'دریافت لیست غذا با خطا مواجه شد', {
              title: 'خطا در دریافت اطلاعات',
              toaster: 'b-toaster-top-right',
              variant: 'danger',
            })
          }
        })
        .catch(error => {
          this.$bvToast.toast(error.response.data.message ?? error.message, {
            title: 'خطا در دریافت اطلاعات',
            toaster: 'b-toaster-top-right',
            variant: 'danger',
          })
        })
        .finally(() => {
          this.onProgress = false
        })
    },
    closeModal() {
      this.showModal = false
    },
    deleteBook(id) {
      this.$http.delete(`reservations/${id}`,
        {
          params: {
            reserve_date: PersianNowDate(this.selectedDay, false, true),
          },
        })
        .then(({ data }) => {
          if (data.status) {
            this.items = this.items.map(item => {
              if (item.id === data.item.id) {
                return data.item
              }
              return item
            })

            this.events = this.events.map(event => {
              if (event.id === data.menu.id) {
                return parsMomentEvent(data.menu, this.$moment)
              }
              return event
            })
            this.showModal = false

            this.$bvToast.toast('حذف رزرو با موفقیت انجام شد.', {
              title: 'رزرو',
              toaster: 'b-toaster-top-right',
              variant: 'success',
            })
          } else {
            this.$bvToast.toast(data.message, {
              title: 'خطا در دریافت اطلاعات',
              toaster: 'b-toaster-top-right',
              variant: 'danger',
            })
          }
        })
        .catch(error => {
          this.$bvToast.toast(error.response.data.message ?? error.message, {
            title: 'خطا در دریافت اطلاعات',
            toaster: 'b-toaster-top-right',
            variant: 'danger',
          })
        })
        .finally(() => {
          this.onProgress = false
        })
    },
    book(id) {
      this.$http.post('reservations',
        {
          id,
          reserve_date: PersianNowDate(this.selectedDay, false, true),
        })
        .then(({ data }) => {
          if (data.status) {
            this.items = this.items.map(item => {
              if (item.id === data.item.id) {
                return data.item
              }
              return item
            })

            this.events = this.events.map(event => {
              if (event.id === data.menu.id) {
                event = parsMomentEvent(data.menu, this.$moment)
              }
              return event
            })
            this.showModal = false

            this.$bvToast.toast('رزرو با موفقیت انجام شد.', {
              title: 'رزرو',
              toaster: 'b-toaster-top-right',
              variant: 'success',
            })
          } else {
            this.$bvToast.toast(data.message, {
              title: 'خطا در دریافت اطلاعات',
              toaster: 'b-toaster-top-right',
              variant: 'danger',
            })
          }
        })
        .catch(error => {
          this.$bvToast.toast(error.response.data.message ?? error.message, {
            title: 'خطا در دریافت اطلاعات',
            toaster: 'b-toaster-top-right',
            variant: 'danger',
          })
        })
        .finally(() => {
          this.onProgress = false
        })
    },
  },
}
</script>

<style>

</style>
